"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _preact = _interopRequireWildcard(require("preact"));

var _settings = require("../../constants/settings");

var _render = require("../../utils/render.utils");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var MainLogo = function MainLogo(_ref) {
  var _ref$display = _ref.display,
      display = _ref$display === void 0 ? true : _ref$display,
      _ref$linksRenderFunct = _ref.linksRenderFunction,
      linksRenderFunction = _ref$linksRenderFunct === void 0 ? null : _ref$linksRenderFunct,
      _ref$doubleLogo = _ref.doubleLogo,
      doubleLogo = _ref$doubleLogo === void 0 ? false : _ref$doubleLogo,
      logoLink = _ref.logoLink,
      logoUrl = _ref.logoUrl,
      logoAlt = _ref.logoAlt,
      subLogoLink = _ref.subLogoLink,
      subLogoUrl = _ref.subLogoUrl,
      subLogoAlt = _ref.subLogoAlt;
  return display ? (0, _preact.h)("div", {
    id: "mtn-header-logos",
    className: "mtn-o-header__logos"
  }, (0, _render.renderLink)(logoLink, (0, _preact.h)("img", {
    id: "mtn-header-logo-main",
    alt: logoAlt || _settings.DEFAULT_LOGO_ALT,
    className: "mtn-o-header__logo ".concat(doubleLogo ? 'mtn-o-header__logo--double' : ''),
    src: logoUrl || _settings.DEFAULT_LOGO
  }), 'mtn-o-header__link', linksRenderFunction, 'mtn-header-logo-main-link'), subLogoUrl && !doubleLogo ? (0, _render.renderLink)(subLogoLink, (0, _preact.h)("img", {
    id: "mtn-header-logo-sub",
    alt: subLogoAlt,
    className: "mtn-o-header__logo",
    src: subLogoUrl
  }), 'mtn-o-header__link', linksRenderFunction, 'mtn-header-logo-sub-link') : null) : null;
};

var _default = MainLogo;
exports["default"] = _default;